<template>
  <div class="image-collect-wrap">
    <div class="left">
      <three-d-model ref="previewModel" :showAiResult="props.showAiResult" :showManualResult="props.showManualResult" :noSort="true" v-show="loading"></three-d-model>
    </div>
    <div class="right" v-if="srcList?.length">
      <title-name>{{$t('design.orderDetail.imageCollectPic') || '影像图片'}}</title-name>
      <div v-if="srcList?.length" class="image-wrap">
        <div v-for="(item, index) in srcList" :key="item.url" class="item">
          <span class="type-name">{{ item.typeName }}</span>
          <xl-image :src="item.url" fit="contain" :preview-src-list="srcList" :initial-index="index" />
          <xl-tooltip :content="item.filename" placement="top">
            <div class="title">{{ item.filename }}</div>
          </xl-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import { XlTooltip, XlImage } from '@shining3d/ui-components';
import ThreeDModel from '../../../components/threeDModel.vue';
import { transModelList, $getCdnUrl } from '../../../utils/common.js';
import TitleName from '../../../components/titleName.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";

const { $t } = useLang("@shining3d/xl-design-order");

const props = defineProps({
  modelData: {
    type: Object,
    default: () => []
  },
  imageData: {
    type: Object,
    default: () => []
  },
  imageSettingInfo: {
    type: Object,
    default: () => []
  },
  previewStatus: {
    type: String,
    default: 'init'
  },
  showAiResult: {
    type: Boolean,
    default: false
  },
  showManualResult: {
    type: Boolean,
    default: false
  }
});

const previewModel = ref( null );
const loading = ref(false);
const setDataModel = (list, status) => {
  previewModel.value?.setData( list, {}, [], status );
  loading.value = true;
}

// watch(() => props.modelData, ( newValue = [], oldValue = [] ) => {
//   if ( JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
//     const list = transModelList( newValue );
//     list.forEach(item => {
//       item.resultType = 'origin';
//     })
//     previewModel.value?.setData( list, {}, [] );
//   }
// }, { immediate: true, deep: true })

const imageExt = ['.png', '.jpg', '.jpeg', '.webp'];
const srcList = ref([]);
watch(() => props.imageData, ( val = []) => {
  if ( val?.length ) {
    const imageSettingMap = props.imageSettingInfo.reduce((obj, cur) => {
      obj[cur.imageUniqueCode] = cur.imageName;
      return obj;
    }, {});
    srcList.value = val.filter(item => imageExt.includes(item.ext)).map((item) => ({
      url: $getCdnUrl({bucket: item?.bucket, dfsID: item?.dfsID}),
      filename: item?.fileName,
      typeName: imageSettingMap[item.detailType]
    }))
  }
}, { immediate: true, deep: true })
defineExpose({setDataModel})
</script>

<style lang="scss" scoped>
.image-collect-wrap {
    width: 100%;
    height: 100%;
    margin-top: 1px;
    display: flex;

    .left {
      flex: 1;
    }
    .right {
      width: 248px;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      border-left: 1px solid #E0E4EA;
      padding: 16px 0px 16px 16px;
      display: flex;
      flex-direction: column;

      .image-wrap {
        flex: 1;
        height: 100%;
        padding-right: 13px;
        overflow-y: auto;

        .item {
          // text-align: center;
          width: 100%;
          overflow: hidden;
          margin-bottom: 16px;
          position: relative;
          &:last-child{
            margin-bottom: 0 !important;
          }
          :deep(.xl-image) {
            height: 121px;
            min-width: 218px;
            border-radius: 6px;
            box-sizing: border-box;
            border: 1px solid #E0E4EA;
          }
          .title {
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            line-height: 18px;
            text-align: left;
            font-size: 12px;
            color: #737E99;
          }
          .type-name {
            position: absolute;
            left: 1px;
            top: 1px;
            z-index: 2;
            height: 24px;
            line-height: 24px;
            background: rgba(85, 135, 255, 0.2);
            backdrop-filter: blur(2px);
            color: rgba(66, 82, 110, 1);
            border-bottom-right-radius: 6px;
            border-top-left-radius: 5px;
            font-family: $font-family65;
            font-size: 12px;
            padding-left: 8px;
            padding-right: 8px;
          }

          &:hover {
            .title {
              color: #5587FF;
            }
            :deep(.xl-image) {
              border-color: #5587FF;
            }
          }
        }
      }
      :deep(.el-image-viewer__canvas) {
        img {
          min-width: 800px;
        }
      }
    }
}
</style>